module.exports = __webpack_public_path__ + "static/media/icon-pin.c19eaaa0.svg";